import {FUIAbstractInput} from "../../framework/abstract-input";
import {ChangeDetectorRef, Directive, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {FUIEventsService} from "../../../events/events.service";
import {FUITimeSelectorComponent} from "../time-selector/time-selector.component";

@Directive()
export abstract class FUIAbstractTimeInput extends FUIAbstractInput implements OnDestroy, OnInit {

    private _selector: FUITimeSelectorComponent;
    private selectorFocusPending: boolean = false;
    private _$click: Subscription;
    public popped: boolean;
    private toggling = false;

    constructor(public elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                protected eventsService: FUIEventsService) {
        super(changeDetectorRef);
    }

    ngOnInit(): void {
        this._$click = this.eventsService.click$.subscribe(
            (click) => {
                if (!this.toggling && this.popped && !this.elementRef.nativeElement.contains(click.target)) {
                    this.popped = false;
                }
            }
        )
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this._$click.unsubscribe();
    }

    @ViewChild('selector')
    set selector(value: FUITimeSelectorComponent) {
        this._selector = value;
        if (this.selectorFocusPending) {
            if (this._selector) {
                this._selector.focus();
            }
            this.selectorFocusPending = false;
        }
    }

    get selector(): FUITimeSelectorComponent {
        return this._selector;
    }

    /**
     *
     * @param {boolean} popped
     */
    public pop(popped: boolean): void {
        this.popped = popped;
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
        this.popped = false;
    }

    toggle(event?: Event) {
        if (!this.disabled && !this.toggling) {
            this.toggling = true;
            setTimeout(() => this.toggling = false);
            this.popped = !this.popped;
            if (this.popped) {
                setTimeout(() => {
                    if (this._selector) {
                        this._selector.focus();
                    } else {
                        this.selectorFocusPending = true;
                    }
                });
            } else {
                this.focus();
            }
            if (event) {
                event.stopPropagation();
            }
        }
    }

    /**
     * If the user presses enter (while not popped) or space, toggle the popup.
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    keypress(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if (((keyboardEvent.code === "Enter" || keyboardEvent.key === "Enter") && !this.popped) ||
                (keyboardEvent.code === "Space" || keyboardEvent.key === " ")) {
                this.toggle(keyboardEvent);
                keyboardEvent.preventDefault();
            }
        }
    }

    /**
     * If the user presses escape (while popped), toggle the popup.
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keydown", ["$event"])
    keydown(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if ((keyboardEvent.code === "Escape" || keyboardEvent.key === "Escape") && this.popped) {
                this.toggle(keyboardEvent);
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
            }
        }
    }

    override onBlur(event?: Event): void {
        super.onBlur(event);
    }

    popClicked(event?: Event) {
        event.stopPropagation();
    }

    selectorChanged(value: Date) {
        this.toggle();
    }
}
